module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    attrs: {
      "id": "PlayerSummaries"
    }
  }, [_vm._l((_vm.playersData.players), function(player) {
    return _h('div', [_h('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfos),
        expression: "showInfos"
      }],
      staticClass: "infos"
    }, ["\n            id: " + _vm._s(player.steamid) + " | last logoff: " + _vm._s(_vm._f("unix2date")(player.lastlogoff)) + " | status: " + _vm._s(_vm.status(player)) + "\n        "]), " ", _h('div', {
      staticClass: "player"
    }, [_h('img', {
      staticClass: "avatar",
      attrs: {
        "src": player.avatarmedium,
        "alt": "player.personaname"
      }
    }), " ", _h('h1', {
      staticClass: "name"
    }, [_vm._s(player.personaname)]), " ", _h('button', {
      staticClass: "toggle",
      on: {
        "click": function($event) {
          _vm.toggleInfos()
        }
      }
    }, ["Infos"])])])
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/vue-loader/lib/template-compiler.js?id=data-v-27c20f64!C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayerSummaries.vue
// module id = 169
// module chunks = 0